/**
 * Params managed internally by GenericDataGrid — these should NOT
 * be included in a bookmark's `targetPath` because they are stored
 * in dedicated bookmark fields (filterConfigJson, columnConfigJson,
 * sortConfigJson) and restored separately by useDataGridState.
 */
const GRID_INTERNAL_PARAMS = new Set([
  'page',
  'pageSize',
  'sortBy',
  'groupBy',
  'filters',
  'columns',
  'bookmarkId',
]);

/**
 * Build a bookmark targetPath that includes page-level search params
 * (e.g. `?tab=feedback&status=Open`) while stripping grid-internal
 * params that are stored in separate bookmark config fields.
 */
export function buildBookmarkTargetPath(pathname: string, search: string): string {
  const params = new URLSearchParams(search);
  const pageLevelParams = new URLSearchParams();
  for (const [key, value] of params) {
    if (!GRID_INTERNAL_PARAMS.has(key)) {
      pageLevelParams.set(key, value);
    }
  }
  const qs = pageLevelParams.toString();
  return qs ? `${pathname}?${qs}` : pathname;
}
